import React from 'react';
import C18ZoneSensors00 from './C18ZoneSensors00'
import C18ZoneEquipment00 from './C18ZoneEquipment00'
import GroupPopup from './GroupPopup'
import {loadSitesInfo,loadZonesInfo,loadGatewaysInfo,getSiteName,getZoneName,getGroupInfo,
  acctFeature
} from './C18utils'
import {dbVals} from '../../components/utils/http';
import {cl,globs,groupHasMixedFw} from '../../components/utils/utils';
import history from "../../history"

class C18ZoneSensorsEquipment00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      mode:"sites",
      showGroupFwPopup:false,
      groupFwPopupMessage:"",
    }
    this.setBreadcrumbs()
    this.checkGroupFwCompat()
//     cl(props)
  }

  componentDidUpdate=(prevProps)=>{
    if(prevProps?.parms?.zone!==this.props?.parms?.zone){
      this.checkGroupFwCompat()
    }
  }

  shouldComponentUpdate=(nextProps,nextState)=>{
    if(globs.dragging) return false
    return true
  }

  // If we're viewing a zone-group, validate all zones in that group
  // against the fw-compatibility rules and surface a warning popup.
  // Runs async because zonesInfo / gatewaysInfo may not be loaded yet
  // when the constructor fires.
  checkGroupFwCompat=async()=>{
    if(!acctFeature("zoneGroups")) return
    const groupId=globs.userData?.session?.groupId
    if(!groupId) return
    // Make sure zones + gateways are loaded before we inspect fwVersions.
    try{
      await Promise.all([loadSitesInfo(), loadZonesInfo(), loadGatewaysInfo()])
    }catch(e){cl(e)}
    const gi=getGroupInfo(groupId)
    if(!gi||!Array.isArray(gi.zones)||gi.zones.length<2) return
    const res=groupHasMixedFw(gi.zones)
//     cl("group fw check", res)
    if(!res.ok){
      let detail=""
      if(res.firstFw||res.conflictFw){
        detail=`\n\nFirmware in group: ${res.firstFw||"Unknown"} and ${res.conflictFw||"Unknown"}`
      }
      this.setState({
        showGroupFwPopup:true,
        groupFwPopupMessage:`${res.reason}\n\nGroup Programming may not work correctly until the firmware versions are the same.`,
      })
    }
  }

  toggleGroupFwPopup=()=>{
    this.setState({showGroupFwPopup:!this.state.showGroupFwPopup})
  }
  
//   onChange=(type)=>{
//     switch(type){
//       case "sensorsWrench":
//         cl("here")
//         this.props.parms.onChange({cmd:type})
// //         history.push(`${this.props.parms.url}/sensor`)
//         break
//       case "equipmentWrench":
//         break
//       default:
//         break
//     }
//     cl(type)
//   }

  setBreadcrumbs=async()=>{
    let pa=this.props.parms
//     cl(this.state)
//     cl(this.props)
    await loadSitesInfo()
    await loadZonesInfo()
    let siteName=getSiteName(this.props.parms.site)
    let zoneName=getZoneName(this.props.parms.zone)
    let zoneEntry={t:zoneName,
      url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`}
    if(acctFeature("zoneGroups")){
      let gi=getGroupInfo(globs.userData.session.groupId)
      if(gi){
        zoneEntry={t:gi.name,
          url:`/usa/c18/sites/${this.props.parms.site}/zones/${gi.groupId}`}
      }
//       cl(gi)
    }
//     if(pa.fwVersion?.split(".")[3]=="I"){// if iDoser zone
//       zoneEntry={t:"iDoser",
//         url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}/pearlDoser`}
//     }
    this.props.parms.onChange(
      {
        cmd: "breadcrumbs",
        data:
          {breadcrumbs: [
            {t:"Sites", url:"/usa/c18/sites"},
            {t:siteName, url:`/usa/c18/sites/${this.props.parms.site}`},
            zoneEntry,
          ]},
      },
    )
  }
  
  
  render(){
//     cl(this.props)
    // cl(dbVals)
    // cl(dbVals.z[2][3][507])
    let pa=this.props.parms
    let st=this.state
    return (
      <div id="content-area">

        <C18ZoneSensors00 parms={{
          onChange: this.props.parms.onChange,
          setZoneError:pa.setZoneError,
          site:this.props.parms.site,
          zone:this.props.parms.zone,
        }}/>
        <C18ZoneEquipment00 parms={{
          onChange:this.props.parms.onChange,
          setZoneError:pa.setZoneError,
          cols:1,//(this.props.parms.sideBarOpen)?2:1,
          site:this.props.parms.site,
          zone:this.props.parms.zone,
          gwType:this.props.parms.gwType,
        }}/>
        <GroupPopup
          open={st.showGroupFwPopup}
          onClose={this.toggleGroupFwPopup}
          title="Warning"
          content={st.groupFwPopupMessage||"Mixed firmware versions detected in this group. Group Programming may not work correctly. Please update all controllers to the same firmware version to use Group Programming."}
        />
      </div>
    )
  }
}
      
export default C18ZoneSensorsEquipment00;
